// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropDownListIcon_SA_icon__1Gcau","selectGroup":"DropDownListIcon_SA_selectGroup__3FAld","selectIcon":"DropDownListIcon_SA_selectIcon__1Gb4z"};